module.exports = ".pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/components/message.modal.scss
// module id = 569
// module chunks = 1